<app-dashboard-container
	[class]="variant() === DashboardVariant.ACTUEEL ? 'dashboard-afwezigheid' : 'dashboard-afwezigheid-historie'"
	[factTable]="factTable"
	[exportTypes]="variant() === DashboardVariant.ACTUEEL ? actueelExportTypes : historieExportTypes"
	(doExport)="this.doExport(filterExpressions(), permanentFilterExpressions, $event)"
>
	<app-filter-panel
		[defaultFilters]="variant() === DashboardVariant.ACTUEEL ? actueelFilters : historieFilters"
		[allFilters]="allFilters()"
		(filterExpressionsChange)="filterExpressions.set($event)"
		endpoint="/aanwezigheid"
		[permanentFilterExpressions]="permanentFilterExpressions"
	></app-filter-panel>
	<app-filter-bar [dataRootSelection]="dataRootSelection()"></app-filter-bar>
	<section class="dashboard">
		<app-dashboard-header>
			<app-toggle-buttons [options]="varianten" [value]="variant()" (valueChange)="qp.dispatch('variant', $event)"></app-toggle-buttons>
			<app-weergave-optie label="Eenheid" param="tijdseenheid" [value]="tijdseenheid()" [enum]="Tijdseenheid"></app-weergave-optie>
			@if (variant() === DashboardVariant.HISTORIE) {
				<app-weergave-optie label="Interval" param="interval" [value]="interval()" [enum]="Interval"></app-weergave-optie>
			}
			<app-legenda
				class="cl-header-utility"
				[attribute]="variant() === DashboardVariant.ACTUEEL ? ['aw_is_abs_geoorloofd'] : ['x_aw_is_abs_geoorloofd_historie']"
			></app-legenda>
		</app-dashboard-header>
		@switch (variant()) {
			@case (DashboardVariant.ACTUEEL) {
				<app-barchart-table
					[filters]="filterExpressions()"
					[permanentFilters]="permanentFilterExpressions"
					[groups]="groeperingService.huidigeGroeperingen()"
					[subgroups]="fixedSubgroups"
					[config]="this"
				></app-barchart-table>
			}
			@case (DashboardVariant.HISTORIE) {
				<app-linechart-table
					[filters]="filterExpressions()"
					[permanentFilters]="permanentFilterExpressions"
					[groups]="historieGroups()"
					[subgroups]="historieSubgroups()"
					[batchLevels]="isHistorieBatchVariant() ? 1 : 0"
					[intervalLevels]="nrIntervalSubgroups()"
					[config]="this.linechartConfig"
				></app-linechart-table>
			}
		}
	</section>
</app-dashboard-container>
